import { createAction, props } from '@ngrx/store';
import { ReportViewerFeatureState } from './report-viewer.reducer';

export const loadFullReport = createAction(
  '[Report] LoadFullReport',
  props<{
    accountId: string;
    reportToken: string;
    reportRunToken: string | null;
  }>()
);

export const loadFullReportSuccess = createAction(
  '[Report] LoadFullReportSuccess',
  props<{
    report: ReportViewerFeatureState;
  }>()
);

export const reportViewRouteLoadReportView = createAction(
  '[Report View Route] Load Report View',
  props<{
    accountId: string;
    reportToken: string;
    reportRunToken?: string;
  }>()
);

export const showLoadingToast = createAction('[Report View Route] Show Loading Toast');

export const reportLoading = createAction(
  '[Report View Route] Report Loading',
  props<{
    toastId: number;
  }>()
);

export const hideLoadingToast = createAction(
  '[Report View Route] Hide Loading Toast',
  props<{
    toastId: number;
  }>()
);

export const apiLoadReportViewSuccess = createAction('[Api] Load Report View Success', props<{ reportView: any }>());
export const apiLoadReportViewFailure = createAction('[Api] Load Report View Failure', props<{ error: any }>());

export const pollForNewReportRuns = createAction(
  '[Report] PollForNewReportRuns',
  props<{
    accountId: string;
    reportToken: string;
    reportRunToken: string;
    onNewReportRun: (newReport: any) => void;
  }>()
);

export const stopPollingForNewReportRuns = createAction('[Report] StopPollingForNewReportRuns');

export const loadQueryRun = createAction(
  '[Report] loadQueryRun',
  props<{
    accountId: string;
    reportToken: string;
    reportRunToken: string;
    queryRunToken: string;
  }>()
);

export const loadQueryRunFailure = createAction(
  '[Report] loadQueryRunFailure',
  props<{
    error: any;
  }>()
);

export const loadReportViewVisualizationsFromExploration = createAction(
  '[Exploration] loadReportViewVisualizations',
  props<{
    accountId: string;
    reportToken: string;
  }>()
);

export const loadReportViewVisualizations = createAction(
  '[Report] loadReportViewVisualizations',
  props<{
    accountId: string;
    reportToken: string;
  }>()
);

export type Union =
  | ReturnType<typeof loadFullReport>
  | ReturnType<typeof loadFullReportSuccess>
  | ReturnType<typeof reportViewRouteLoadReportView>
  | ReturnType<typeof apiLoadReportViewSuccess>
  | ReturnType<typeof apiLoadReportViewFailure>
  | ReturnType<typeof pollForNewReportRuns>
  | ReturnType<typeof stopPollingForNewReportRuns>
  | ReturnType<typeof loadQueryRun>
  | ReturnType<typeof loadQueryRunFailure>;
